import React, { useState } from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const FeaturesTabs: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const tabs = (c.tabs || []) as Array<{ tab_label: string; title: string; description: string; image_url?: string }>;
  const [activeTab, setActiveTab] = useState(0);
  const active = tabs[activeTab];

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ textAlign: 'center', marginBottom: 32 }}
        >
          {sfHeadline(c, 'Features')}
        </InlineEditText>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 32 }}>
          {tabs.map((t, i) => (
            <button key={i} onClick={() => setActiveTab(i)} style={{
              padding: '8px 20px', borderRadius: 6, border: 'none', cursor: 'pointer',
              background: i === activeTab ? 'var(--brand-primary, #2563eb)' : '#f1f5f9',
              color: i === activeTab ? '#fff' : '#475569', fontWeight: 600, fontSize: '0.875rem',
            }}>
              {t.tab_label}
            </button>
          ))}
        </div>
        {active && (
          <div style={{ display: 'grid', gridTemplateColumns: active.image_url ? '1fr 1fr' : '1fr', gap: 48, alignItems: 'center' }}>
            <div>
              <h3 style={{ fontSize: '1.5rem', marginBottom: 12 }}>{active.title}</h3>
              <p style={{ color: '#64748b', lineHeight: 1.6 }}>{active.description}</p>
            </div>
            {active.image_url && <img src={active.image_url} alt="" style={{ width: '100%', borderRadius: 12 }} />}
          </div>
        )}
      </div>
    </section>
  );
};
export default FeaturesTabs;
